import axios from 'axios';

/**
 * ⚠️ MÜHİT DƏYİŞƏNİNDƏN GƏLİR, KODA YAZILMIR — bax `client/src/services/api.ts`.
 * Serverdə əl ilə redaktə edilən sabit ünvan `git pull`-da itirdi və panel
 * canlıda `localhost`-a sorğu atırdı.
 */
export const API_URL =
  import.meta.env.VITE_API_URL ?? 'http://localhost:3000/api/v1';

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor to add JWT token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * ⛔ Vaxtı bitmiş token.
 *
 * JWT 24 saat sonra bitir, amma `AdminLayout` yalnız tokenin MÖVCUDLUĞUNU yoxlayırdı.
 * Nəticədə panel səni girmiş sayırdı, hər sorğu isə 401 alırdı — istifadəçi
 * bütün səhifələrdə «Failed to load data» görürdü və heç vaxt giriş ekranına
 * qaytarılmırdı. İndi 401-də token silinir və giriş səhifəsinə yönləndirilir.
 *
 * Giriş sorğusunun özü istisnadır: səhv parolda 401 gəlir, o, sadəcə
 * «parol yanlışdır» deməkdir, yönləndirmə lazım deyil.
 */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url: string = error?.config?.url ?? '';
    const isLoginRequest = url.includes('/auth/');

    if (status === 401 && !isLoginRequest) {
      localStorage.removeItem('token');
      if (!window.location.pathname.startsWith('/login')) {
        window.location.replace('/login');
      }
    }

    return Promise.reject(error);
  },
);

export const AdminAPI = {
  auth: {
    login: (credentials: any) => api.post('/auth/admin/login', credentials),
    getProfile: () => api.get('/auth/profile'),
    getAdmins: () => api.get('/admins'),
  },
  content: {
    getPosts: () => api.get('/admin/content/posts'), 
    getPost: (id: string) => api.get(`/admin/content/posts/${id}`),
    createPost: (data: any) => api.post('/admin/content/posts', data),
    updatePost: (id: string, data: any) => api.put(`/admin/content/posts/${id}`, data),
    deletePost: (id: string) => api.delete(`/admin/content/posts/${id}`),
  },
  uploads: {
    uploadImage: (file: File) => {
      const formData = new FormData();
      formData.append('file', file);
      return api.post('/uploads/image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
  },
  gameplay: {
    getQuizzes: () => api.get('/admin/gameplay/quizzes'),
    createQuiz: (data: any) => api.post('/admin/gameplay/quiz', data),
    updateQuiz: (id: string, data: any) => api.put(`/admin/gameplay/quiz/${id}`, data),
    deleteQuiz: (id: string) => api.delete(`/admin/gameplay/quiz/${id}`),
    createLevel: (data: any) => api.post('/admin/gameplay/level', data),
  },
  categories: {
    getAll: () => api.get('/admin/categories'),
    create: (data: any) => api.post('/admin/categories', data),
    update: (id: string, data: any) => api.patch(`/admin/categories/${id}`, data),
    delete: (id: string) => api.delete(`/admin/categories/${id}`),
  },
  pages: {
    /** Səhifənin dəyişdirilmiş mətnləri (dəyişməyən sahələr cavabda olmur) */
    get: (key: string) => api.get(`/admin/pages/${key}`),
    /** Yalnız ilkin mətndən FƏRQLƏNƏN sahələr göndərilir — qalanları silinir */
    save: (
      key: string,
      data: {
        fieldsAz: Record<string, string>;
        fieldsEn: Record<string, string>;
        assets: Record<string, string>;
      },
    ) => api.put(`/admin/pages/${key}`, data),
  },
  community: {
    getDiscussions: () => api.get('/admin/community/discussions'),
    deleteDiscussion: (id: string, reason: string) => api.delete(`/admin/community/discussions/${id}`, { data: { reason } }),
  }
};
